import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'

import 'swiper/css'

interface Props {
   title?: string,
   sliderItems?: {
      src: string,
      alt: string,
   }[],
   color?: string,
}

export default function MarqueeSlider(props: Props) {
   const { sliderItems, title, color } = props

   return (
      <>
         {(title || sliderItems) && <div className={`grid-container marquee-slider ${color === 'secondary' ? 'marquee-slider--secondary' : ''}`}>
         <div className="marquee-slider__wrapper">
            {title && <div className="title font-title">{title}</div>}
            {sliderItems &&
               <Swiper
                  className="wrapper swiper"
                  modules={[Autoplay]}
                  loop={true}
                  autoplay={{
                     delay: 0,
                     disableOnInteraction: false,
                     pauseOnMouseEnter: false,
                  }}
                  breakpoints={{
                     0: {
                        slidesPerView: 1,
                        spaceBetween: 60,
                     },
                     475: {
                        slidesPerView: 2,
                     },
                     992: {
                        slidesPerView: 3,
                     },
                     1240: {
                        spaceBetween: 120,
                     },
                     1440: {
                        slidesPerView: 4,
                        spaceBetween: 200,
                     },
                  }}
                  speed={2750}
                  navigation={false}
                  freeMode={true}
                  spaceBetween={200}
               >
                  {sliderItems.map((item, index) => (
                     <SwiperSlide key={index}>
                        <img src={item.src} alt={item.alt} />
                     </SwiperSlide>
                  ))}
               </Swiper>
            }
         </div>
      </div>}
      </>
   )
}